export default __webpack_public_path__ + "static/media/foll.0e269fb5.wav";